import store from "@/pages/cathayfitback/store";

const state = {
  default_title: "",
  title_list: []
};

const getters = {
  getTitle: state => page_name => {
    const page_title = state.title_list.find(ele => {
      return ele.func_id == page_name;
    });
    const rtnTitle = page_title ? page_title.meta_value : state.default_title;
    return rtnTitle || state.default_title;
  }
};

const actions = {
  setMata({ commit }, obj) {
    return new Promise((resolve, rejects) => {
      if (store.state.meta.title_list.length) {
        commit("setMata", obj);
        resolve(true);
      }
    });
  }
};

const mutations = {
  setMata(state, obj) {
    state.title_list = obj;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
